module.exports = __webpack_public_path__ + "static/media/banner-news.2873dfa9.png";